import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AbsenceService } from './api/absence.service';
import { ActionService } from './api/action.service';
import { AttendenceService } from './api/attendence.service';
import { AttendenceSettingService } from './api/attendenceSetting.service';
import { AuthorizationService } from './api/authorization.service';
import { CardService } from './api/card.service';
import { CenterService } from './api/center.service';
import { DashboardService } from './api/dashboard.service';
import { DeviceService } from './api/device.service';
import { RoleService } from './api/role.service';
import { TerminalService } from './api/terminal.service';
import { UserService } from './api/user.service';
import { UsersGroupService } from './api/usersGroup.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
